// src/components/EmbedsShowcase.tsx
import { ForceReloadLink } from './ForceReloadLink';
import { Code, Target, DollarSign, Calendar, TrendingUp } from 'lucide-react';

export function EmbedsShowcase() {
  return (
    <div className="mt-6 bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
      <div className="flex items-center gap-3 mb-4">
        <Code className="w-6 h-6 text-primary" />
        <h2 className="text-xl font-semibold text-gray-900">Embed Our Calculators On Your Website</h2>
      </div>
      
      <p className="text-gray-600 mb-6">
        Add our interactive calculators to your website for free. Help your visitors make informed 
        decisions about home buying without leaving your site. Great for real estate agents, mortgage 
        brokers, and financial advisors.
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <ForceReloadLink 
          to="/home-affordability-embed" 
          className="p-4 border border-gray-200 rounded-lg hover:border-primary hover:shadow-md transition-all"
        >
          <div className="flex items-center gap-2 mb-2">
            <Target className="w-4 h-4 text-primary flex-shrink-0" />
            <h3 className="font-medium text-gray-900">Affordability Calculator</h3>
          </div>
          <p className="text-sm text-gray-600 mb-3">Help visitors determine how much house they can afford.</p>
          <span className="text-sm font-medium text-primary flex items-center">
            Get Embed Code →
          </span>
        </ForceReloadLink>
        
        <ForceReloadLink 
          to="/mortgage-payment-embed" 
          className="p-4 border border-gray-200 rounded-lg hover:border-primary hover:shadow-md transition-all"
        >
          <div className="flex items-center gap-2 mb-2">
            <DollarSign className="w-4 h-4 text-primary flex-shrink-0" />
            <h3 className="font-medium text-gray-900">Mortgage Calculator</h3>
          </div>
          <p className="text-sm text-gray-600 mb-3">Help visitors calculate monthly mortgage payments.</p>
          <span className="text-sm font-medium text-primary flex items-center">
            Get Embed Code →
          </span>
        </ForceReloadLink>
        
        <ForceReloadLink 
          to="/purchase-timeline-embed" 
          className="p-4 border border-gray-200 rounded-lg hover:border-primary hover:shadow-md transition-all"
        >
          <div className="flex items-center gap-2 mb-2">
            <Calendar className="w-4 h-4 text-primary flex-shrink-0" />
            <h3 className="font-medium text-gray-900">Future Purchase Calculator</h3>
          </div>
          <p className="text-sm text-gray-600 mb-3">Help visitors plan when they'll be ready to buy.</p>
          <span className="text-sm font-medium text-primary flex items-center">
            Get Embed Code →
          </span>
        </ForceReloadLink>
        
        <ForceReloadLink 
          to="/down-payment-embed" 
          className="p-4 border border-gray-200 rounded-lg hover:border-primary hover:shadow-md transition-all"
        >
          <div className="flex items-center gap-2 mb-2">
            <TrendingUp className="w-4 h-4 text-primary flex-shrink-0" />
            <h3 className="font-medium text-gray-900">Down Payment Calculator</h3>
          </div>
          <p className="text-sm text-gray-600 mb-3">Help visitors plan their down payment savings.</p>
          <span className="text-sm font-medium text-primary flex items-center">
            Get Embed Code →
          </span>
        </ForceReloadLink>
      </div>
      
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
        <h3 className="font-medium text-gray-900 mb-2">Why Add Our Calculators to Your Website?</h3>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
          <li className="flex items-start gap-2">
            <span className="text-primary font-bold">✓</span>
            <span className="text-gray-700">Free with no sign-up required</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary font-bold">✓</span>
            <span className="text-gray-700">No ads or distracting content</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary font-bold">✓</span>
            <span className="text-gray-700">Mobile-friendly responsive design</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary font-bold">✓</span>
            <span className="text-gray-700">Keeps visitors on your website longer</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary font-bold">✓</span>
            <span className="text-gray-700">Customizable default values</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary font-bold">✓</span>
            <span className="text-gray-700">Integrate with your CMS variables</span>
          </li>
        </ul>
      </div>
    </div>
  );
}